<script setup>
// TODO: Change file name to LayoutMap (or create LayoutMap) add to layout folder
import { ref, computed, onMounted } from 'vue';
import { useSessionStore } from "@/stores/SessionStore";
import { useUserStore } from "@/stores/UserStore";
import { useMapUIStore } from "@/stores/MapUIStore";
import { useMapStore } from "@/stores/MapStore";
import { useStormStore } from "@/stores/StormStore";

import { useMediaQuery } from '@/composables/useMediaQuery';

import MapSidebar from '@/components/MapSidebar.vue';
import MapName from '@/components/MapName.vue'
import MapRegionalNavigation from '@/components/MapRegionalNavigation.vue'
import MapControlsPrimary from '@/components/MapControlsPrimary.vue'
import MapControlsSecondary from '@/components/MapControlsSecondary.vue'
import MapUpgradeButton from '@/components/MapUpgradeButton.vue'
import MapDashboard from '@/components/MapLayerDashboards.vue'
import MapTimeline from '@/components/MapTimeline.vue'
import MapModelSelector from '@/components/MapModelSelector.vue'
import MapUserProfileSelector from '@/components/MapUserProfileSelector.vue'
import MapLegend from '@/components/MapLegend.vue'
import SheetsContainer from '@/components/SheetsContainer.vue'
import MapMessages from "@/components/MapMessages.vue";
import MapStormHeader from "@/components/MapStormHeader.vue";
import MapStormTrack from "@/components/MapStormTrack.vue";
import StormMap from "@/components/StormMap.vue";
import MapFooterBannerAd from "@/components/MapFooterBannerAd.vue";

import useSettingsGlobals from '@/composables/useSettingsGlobals';
import useMapConfigurationGlobals from '@/composables/useMapConfigurationGlobals';
import useConfigurationGlobals from '@/composables/useConfigurationGlobals';

const { $BRAND } = useConfigurationGlobals();
const { $STORM_TRACK, $STORM_CENTER, $WEB_VIEW, $PLATFORM } = useSettingsGlobals();
const { $MAP_NAME_BLOCK, $STORM_HEADER_BLOCK } = useMapConfigurationGlobals();

window.$JWX = {}
window.$JWX.ready = false;

setPageDatasets();

const sessionStore = useSessionStore();
const stormStore = useStormStore();
await stormStore.getStormsData();

if (stormStore.hasActiveStorms) {
  await sessionStore.getToken();
  
  if (window.jweather) {
    window.jweather.token = sessionStore.token;
  } else {
    window.jweather = {
      token: sessionStore.token
    };
  }
}

const mapStore = useMapStore();
const mapUIStore = useMapUIStore();
const userStore = useUserStore();

const isDesktop = useMediaQuery('(min-width: 840px)');

const queryString = window.location.search;
const urlParams = new URLSearchParams(queryString);
const stormId = urlParams.get('storm_id');

if (stormId) stormStore.setSelectedStorm(stormId);

let mapReady = ref(false);

// userStore.checkToken();

mapUIStore.updateTheme();
mapUIStore.toggleLegend();

const showModelSelector = computed(() => mapReady.value && mapStore.mapMode.toLowerCase() === 'fx' && mapStore.state.forecastSelectorNeeded);
const showProfileSelector = computed(() =>  mapReady.value && mapStore.state.searchType === 'profile');
const showUpgradeButton = computed(() => userStore.memberLevel < 49 && mapStore.state.overlays['markers']);
const showMapMessages = computed(() => userStore.messages && userStore.messages.length > 0 && parseInt(userStore.nonTrialMemberLevel) < 49);
const showStormTrack= computed(() => mapReady.value && $STORM_CENTER && stormStore.activeStorms.length > 0);

onMounted(() => {
  if (stormStore.activeStorms.length === 0 && !$WEB_VIEW) {
    window.location = `https://wx.${$BRAND}.com/storm`;

    return;
  }

  mapUIStore.isStormTrackUI($STORM_TRACK);
  
  mapUIStore.$subscribe(() => {
    mapUIStore.updateTheme();
    mapUIStore.toggleLegend();
  });

  window.$JWX.ready = true;
  window.$EventBus.dispatchEvent('jwx-ready');
});

function setPageDatasets() {
  const body = document.documentElement;

  if ($WEB_VIEW) {
    body.dataset.webView = true;
    body.dataset.platform = $PLATFORM.toLowerCase();
  }
}

</script>

<template>
  <StormMap
    v-model:mapReady="mapReady"
  />
  <MapMessages v-if="showMapMessages" />
  
  <MapRegionalNavigation v-if="mapUIStore.showRegionalNavigation" />
  <MapSidebar v-if="mapReady" />
  <MapStormTrack v-if="showStormTrack" />
  <MapStormHeader v-if="$STORM_HEADER_BLOCK" />
  <div class="jwx-map__header" v-if="$MAP_NAME_BLOCK">
    <MapName />
  </div>
  <MapControlsPrimary />
  <div v-if="isDesktop" class="jwx-map__shared">
    <MapControlsSecondary />
  </div>
  <MapUpgradeButton v-if="showUpgradeButton" />
  <MapDashboard />
  <MapModelSelector v-if="showModelSelector" />
  <MapUserProfileSelector v-if="showProfileSelector" />
  <MapTimeline v-if="mapReady" />
  <MapFooterBannerAd />
  <MapLegend />
  <SheetsContainer />
</template>